export default "__VITE_ASSET__2PEsOx7___"